import React from "react";
import Grid from "@material-ui/core/Grid";
import classes from "./Notification.module.css";
import { getTime, isRecentNotification } from "./notificationutils";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { connect, Provider } from "react-redux";
import { getAssessmentResponce } from "../../store/actions/questionAnswer.action";
import { readAssessment } from "../../store/actions/assessment.action";
import { clearQuestion } from "../../store/actions/questions.action";
import assessmentService from "../../store/services/assessment.service";

class NewAssessmentNotification extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      notificationtime: "Just Now",
      isNew: false,
    };
  }

  componentDidMount() {
    this.setState({ notificationtime: getTime(this.props.info.createdAt) });
    this.setState({ isNew: isRecentNotification(this.props.info.createdAt) });
  }

  startTest = async () => {
    let userId = localStorage.getItem("kneuraId");
    const assessmentId = this.props.info.assessmentId;
    const { isRolledBack } = await assessmentService.isRolledBack(assessmentId);
    if (isRolledBack) {
      this.props.history.push("/start-test?assessmentId=" + assessmentId);
    }

    await this.props.getAssessmentResponce(assessmentId, userId);
    localStorage.setItem("_assessmentId", this.props.info.assessmentId);
    if (
      this.props.assessmentresponse.status == "NotAttempted" ||
      this.props.assessmentresponse.status == "InProgress"
    ) {
      this.props.history.push(
        "/start-test?assessmentId=" + this.props.info.assessmentId
      );
    } else if (this.props.assessmentresponse.status == "Completed") {
      let assessmentId = localStorage.getItem("_assessmentId");
      await this.props.clearQuestion();
      await this.props.readAssessment(assessmentId);
      this.props.history.replace("/test-submitted");
    }
  };

  render() {
    const { t } = this.props;
    return (
      <div className={classes.MesGrid}>
        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="flex-start"
          wrap="nowrap"
        >
          <div
            className={
              this.state.isNew
                ? classes.newNotificationMesHeader
                : classes.notificationMesHeader
            }
          >
            {t("New Assessment")}
          </div>
          <div
            className={
              this.state.isNew
                ? classes.newNotificationDateMesHeader
                : classes.notificationDateMesHeader
            }
          >
            {this.state.notificationtime}
          </div>
        </Grid>
        <div className={classes.notificationMes} onClick={this.startTest}>
          <b /> {t("Published a new assessment")}{" "}
          <b>{this.props.info.assessmentName}</b>
        </div>
        <div
          className={
            this.state.isNew ? classes.NewMesDivider : classes.MesDivider
          }
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    assessmentresponse: state.questionanswer.assessmentresponse,
  };
};

export default connect(mapStateToProps, {
  getAssessmentResponce,
  readAssessment,
  clearQuestion,
})(withRouter(withTranslation()(NewAssessmentNotification)));
